export default "__VITE_ASSET__Cvgj$c3J__"